import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'redux';
import TermsAndConditions from './TermsAndConditions';
import { actionCreators } from './store.js';

class TermsAndConditionsContainer extends React.Component {
  componentDidMount() {}

  onClickDismiss = () => {
    this.props.history.push('/Logout');
  };

  onClickAccept = () => {
    this.props.updateTCAccepted();
  };

  onChangeAcceptTermsAndConditions = (event, checked) => {
    this.props.updateTCAccpetChecked(checked);
  };

  scrolledToEnd = () => {
    this.props.updateTCRead(true);
  };

  render() {
    const { showModal, hasAcceptedTC, tcRead, tcAccpetChecked } = this.props;

    return (
      <Fragment>
        <TermsAndConditions
          showModal={showModal}
          open={!hasAcceptedTC}
          scrolledToEnd={this.scrolledToEnd}
          tcRead={tcRead}
          tcAccpetChecked={tcAccpetChecked}
          onClickDismiss={this.onClickDismiss}
          onChangeAcceptTermsAndConditions={
            this.onChangeAcceptTermsAndConditions
          }
          onClickAccept={this.onClickAccept}
        />
      </Fragment>
    );
  }
}

TermsAndConditionsContainer.propTypes = {
  hasAcceptedTC: PropTypes.bool,
  showModal: PropTypes.bool,
};

export default compose(
  withRouter,
  connect(
    (state) => ({
      permissions: state.auth.permissions,
      hasAcceptedTC: state.auth.hasAcceptedTC,
      accessToken: state.auth.accessToken,
      tcRead: state.termsAndConditions.tcRead,
      tcAccpetChecked: state.termsAndConditions.tcAccpetChecked,
    }),
    {
      updateTCAccepted: actionCreators.updateTCAccepted,
      updateTCRead: actionCreators.updateTCRead,
      updateTCAccpetChecked: actionCreators.updateTCAccpetChecked,
    }
  )
)(TermsAndConditionsContainer);
